import { useState } from "react";


const initKruxTracking = (kruxData = {}) => {
	window.KruxData = kruxData;
	const Krux = window.Krux || (((...args) => { Krux.q.push(args); }).q = []);

	function retrieve(n) {
		let m; const k = `_kx${n}`; const
			ls = (() => {
				try {
					return window.localStorage;
				} catch (e) {
					return null;
				}
			})();

		if (ls) {
			return ls[k] || "";
		} else if (navigator.cookieEnabled) {
			m = document.cookie.match(`${k}=([^;]*)`);
			return (m && unescape(m[1])) || "";
		} else {
			return "";
		}
	}

	Krux.user = retrieve("user");
	Krux.segments = retrieve("segs") ? retrieve("segs").split(",") : [];

	// DFP Premium Interchange
	const dfpp = [];

	if (Krux.user) {
		dfpp.push(`kuid=${Krux.user}`);
	}

	Krux.segments.forEach((segment) => dfpp.push(`ksg=${segment}`));
	Krux.dfppKeyValues = dfpp.length ? `${dfpp.join(";")};` : "";
};

function useKruxTracking({ adFree, kruxData }) {
	const [hasLoaded, setHasLoaded] = useState(false);

	if (!adFree && !hasLoaded) {
		// Krux script tag is loaded in: src/routers/index.html
		initKruxTracking(kruxData);
		setHasLoaded(true);
	}
}

export default useKruxTracking;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/useKruxTracking.js